export default {
  methods: {
    formatLogAction(log) {
      switch (log.action) {
        case 'cancel':
          return 'cancelamento';
        case 'change':
          return 'mudança de contato';
        case 'close':
          return 'encerramento';
        case 'convert':
          return 'geração PDFA para junta';
        case 'create':
          return 'criação';
        case 'delete':
          return 'exclusão';
        case 'edit':
          return 'edição';
        case 'open':
          return 'abertura';
        case 'sign':
          return 'assinatura';
        default:
          return '-';
      }
    },
    formatLogModel(log) {
      switch (log.model) {
        case 'Signer':
          return 'Assinante';
        case 'Book':
          return 'Livro';
        case 'BookSAStockRegistry':
          return 'Registro no livro de ações';
        case 'BookSADebentureRegistry':
          return 'Registro no livro de debêntures';
        case 'Company':
          return 'Empresa';
        case 'Debenture':
          return 'Debênture';
        case 'Document':
          return 'Documento';
        case 'Folder':
          return 'Pasta';
        case 'User':
          return 'Usuário';
        case 'Stock':
          return 'Ação';
        case 'Session':
          return 'Sessão';
        default:
          return '-';
      }
    },
  },
};
